import { CustomToolbar } from '../universal/GridHelper';
import SyncIcon from '@mui/icons-material/Sync';
import { ArrowForward }  from '@mui/icons-material';
import { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid'
import { SelectGenericFromTable } from '../universal/Axios';
import { observer } from "mobx-react"
import { GetPerformancePercentile, GetMean, GetMedian } from '../universal/InternalCalculator';
import * as React from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import { getStore } from '../../Store'
import Tooltip from '@mui/material/Tooltip';
import apiClient from '../../apiClient';
const store = getStore();

const NetworkRunQueueTable = observer(({ network_batch_id }) => {
    const [completeWithAnalyticsProgress, setCompleteWithAnalyticsProgress] = React.useState(0);
    const [buffer, setBuffer] = React.useState(0);
    const [networkRunQueueData, setNetworkRunQueueData] = useState([]);
    const [totalActivePercentage, setTotalActivePercentage] = useState("100%");
    const [queuedCount, setQueuedCount] = useState(0);
    const [runningCount, setRunningCount] = useState(0);
    const [inProgressCount, setInProgressCount] = useState(0);
    const [errorCount, setErrorCount] = useState(0);
    const [erroredOutCount, setErroredOutCount] = useState(0);
    const [completeCount, setCompleteCount] = useState(0);
    const [runningAnalyticsCount, setRunningAnalyticsCount] = useState(0);
    const [completeWithScoreAndAnalyticsCount, setCompleteWithScoreAndAnalyticsCount] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [triggerCount, setTriggerCount] = useState(false);
    var where_clause = (network_batch_id == null || network_batch_id === "") ? "" : " WHERE network_batch_id = '" + network_batch_id + "';"

    const updateBatchStatus = () => {
        store.updateStatusMessage("Updating batch status...")
        apiClient.post(
            "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
            {
                "function_to_execute": "Update_Batch_Status",
                "network_batch_id": network_batch_id,
            }
        ).then(({ data }) => {
            setTriggerCount(!triggerCount)
            store.updateSuccessMessage("Updated batch status")
            window.location.reload()
        }).catch(function (error) {
            store.updateErrorMessage("Error: " + error)
        })
    }

    const triggerNetworkBatch = () => {
        //console.log('Instance ID:', axios.defaults.__debugInstanceId);
        //console.log('AUTH AT REQUEST TIME:', apiClient.defaults.headers.common.Authorization);
        store.updateStatusMessage("Triggering network batch...")
        apiClient.post(
            "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
            {
                "function_to_execute": "Handle_Batch_Network_Run_Queues_By_Batch_ID",
                "network_batch_id": network_batch_id,
            }
        ).then(({ data }) => {
            store.updateSuccessMessage("Successfully triggered network batch!")
        }).catch(function (error) {
            store.updateErrorMessage("Error while triggering network batch")
        })
    }
    useEffect(() => {
        SelectGenericFromTable("select nrq.*, af.name as combined_audio_name from network_run_queue nrq JOIN signal_noise_separation_input snsi on nrq.signal_noise_separation_input_id = snsi.id join audio_file af on af.id = snsi.combined_audio_file_id " + where_clause, setNetworkRunQueueData)
    }, [triggerCount]);
    useEffect(() => {
        setQueuedCount("...")
        setRunningCount("...")
        setInProgressCount("...")
        setErrorCount("...")
        setErroredOutCount("...")
        setCompleteCount("...")
        setRunningAnalyticsCount("...")
        setCompleteWithScoreAndAnalyticsCount("...")
        setTotalCount("...")

        let queued_networks = networkRunQueueData?.filter(data => data["status"] === "QUEUED");
        let running_networks = networkRunQueueData?.filter(data => data["status"] === "RUNNING");
        let in_progress_networks = networkRunQueueData?.filter(data => data["status"] === "IN_PROGRESS");
        let error_networks = networkRunQueueData?.filter(data => data["status"] === "ERROR");
        let errored_out_networks = networkRunQueueData?.filter(data => data["status"] === "ERRORED_OUT");
        let complete_networks = networkRunQueueData?.filter(data => data["status"] === "COMPLETE");
        let running_analytics_networks = networkRunQueueData?.filter(data => data["status"] === "RUNNING_SCORE_AND_ANALYTICS");
        let complete_with_score_and_analytics_networks = networkRunQueueData?.filter(data => data["status"] === "COMPLETE_WITH_SCORE_AND_ANALYTICS");

        setTimeout(() => {
            setQueuedCount(queued_networks.length)
            setRunningCount(running_networks.length)
            setInProgressCount(in_progress_networks.length)
            setErrorCount(error_networks.length)
            setErroredOutCount(errored_out_networks.length)
            setTotalCount(networkRunQueueData.length)
            setCompleteCount(complete_networks.length)
            setRunningAnalyticsCount(running_analytics_networks.length)
            setCompleteWithScoreAndAnalyticsCount(complete_with_score_and_analytics_networks.length)
        }, 500);

        setBuffer(running_networks.length / (networkRunQueueData.length) * 100);
        setCompleteWithAnalyticsProgress(complete_with_score_and_analytics_networks.length / (complete_with_score_and_analytics_networks.length + running_networks.length) * 100);
        let total_active_percentage = ((complete_with_score_and_analytics_networks.length + running_networks.length) / networkRunQueueData.length * 100).toString() + "%";
        setTotalActivePercentage(total_active_percentage);
    }, [networkRunQueueData])

    if (networkRunQueueData === undefined) {
        return (<p>loading...</p>)
    }

    const networkRunColumns = [
        {
            field: 'id',
            headerName: 'ID',
            width: 300,
        },
        {
            field: 'network_run_id',
            headerName: 'Network_Run_ID',
            width: 300,
            hide: true
        },
        {
            field: 'combined_audio_name',
            headerName: 'Combined Audio File',
            width: 400,
        },
        {
            field: 'density_network_config_id',
            headerName: 'Density Network Config ID',
            width: 500,
            renderCell: (params) => (
                <>
                    <a
                        href={'edit-density-network-config?id=' + params.row.density_network_config_id}
                        target="_blank"
                    >
                        {params.row.density_network_config_id}
                    </a>
                </>
            ),
        },
        {
            field: 'si_sdr',
            headerName: 'SI-SDR',
            width: 80,
            renderCell: (params) => (
                params.value != null ?
                    <span style={{ color: 'rgb(' + ((1 - parseFloat(params.row.relative_si_sdr)) * 255) + ',' + (parseFloat(params.row.relative_si_sdr) * 255) + ',0)' }}
                    >
                        {params.value.toString()}
                    </span> : <span></span>
            ),
        },
        {
            field: 'speech_signal_consolidation_score',
            headerName: 'Signal Consolidation Score',
            width: 80,
            renderCell: (params) => (
                params.value != null ?
                    <span style={{ color: 'rgb(' + ((1 - parseFloat(params.row.relative_speech_signal_consolidation_score)) * 255) + ',' + (parseFloat(params.row.relative_speech_signal_consolidation_score) * 255) + ',0)' }}
                    >
                        {params.value.toString()}
                    </span> : <span></span>
            ),
        },
        {
            field: 'speech_transform_activation_score',
            headerName: 'Speech Transform Activation Score',
            width: 80,
            renderCell: (params) => (
                params.value != null ?
                    <span style={{ color: 'rgb(' + ((1 - parseFloat(params.row.relative_speech_transform_activation_score)) * 255) + ',' + (parseFloat(params.row.relative_speech_transform_activation_score) * 255) + ',0)' }}
                    >
                        {params.value.toString()}
                    </span> : <span></span>
            ),
        },
        {
            field: 'speech_channel_assignment_score',
            headerName: 'Channel Assignment Score',
            width: 80,
        },
        {
            field: 'actions',
            headerName: '',
            width: 105,
            renderCell: (params) => (
                <>
                    <a href={"/output-files?id=" + params.row.network_run_id + "&snsi_id=" + params.row.signal_noise_separation_input_id} target="_blank">
                        <Button
                            variant="contained"
                            style={{ textTransform: "none", marginRight: "5px" }}
                        >
                            Output
                        </Button>
                    </a>
                </>
            ),
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 300,
        },
        {
            field: 'persister_config_id',
            headerName: 'Persister Config ID',
            width: 500,
            renderCell: (params) => (
                <>
                    {params.row.persister_config_id}
                </>
            ),
        },
        {
            field: 'signal_noise_separation_input_id',
            headerName: 'signal_noise_separation_input_id',
            hide: true
        }
    ];

    let networkRunQueueDataRows = networkRunQueueData?.filter(data => data != null).map((networkRunQueue) =>
    ({
        id: networkRunQueue.id,
        network_run_id: networkRunQueue.network_run_id,
        name: networkRunQueue.name,
        combined_audio_name: networkRunQueue.combined_audio_name,
        description: networkRunQueue.description,
        audio_source_folder: networkRunQueue.audio_source_folder,
        density_network_config_id: networkRunQueue.density_network_config_id,
        persister_config_id: networkRunQueue.persister_config_id,
        run_date: networkRunQueue.run_date,
        si_sdr: networkRunQueue.si_sdr,
        speech_signal_consolidation_score: networkRunQueue.speech_signal_consolidation_score,
        speech_transform_activation_score: networkRunQueue.speech_transform_activation_score,
        speech_channel_assignment_score: networkRunQueue.speech_channel_assignment_score,
        status: networkRunQueue.status,
        network_batch_id: networkRunQueue.network_batch_id,
        signal_noise_separation_input_id: networkRunQueue.signal_noise_separation_input_id,
    }))
    networkRunQueueDataRows = GetPerformancePercentile(networkRunQueueDataRows, 'si_sdr', 'relative_si_sdr', 0);
    networkRunQueueDataRows = GetPerformancePercentile(networkRunQueueDataRows, 'speech_signal_consolidation_score', 'relative_speech_signal_consolidation_score', 0);
    networkRunQueueDataRows = GetPerformancePercentile(networkRunQueueDataRows, 'speech_transform_activation_score', 'relative_speech_transform_activation_score', 0);
    var mean = GetMean(networkRunQueueDataRows.filter(x => x['si_sdr'] != null).map(x => x['si_sdr']))
    var median = GetMedian(networkRunQueueDataRows.filter(x => x['si_sdr'] != null).map(x => x['si_sdr']))
    return (
        <>
            {mean != undefined && <h3 style={{ marginBottom: '0' }}>Mean SI-SDR: {mean}</h3>}
            {median != undefined && <h3 style={{ marginTop: '0' }}> Median SI-SDR: {median}</h3>}
            Queued Count: {queuedCount} / {totalCount}
            <br />
            Running Count: {runningCount} / {totalCount}
            <br />
            In Progress Count: {inProgressCount} / {totalCount}
            <br />
            Error Count: {errorCount} / {totalCount}
            <br />
            Errored Out Count: {erroredOutCount} / {totalCount}
            <br />
            Complete Count: {completeCount} / {totalCount}
            <br />
            Running Score and Analytics: {runningAnalyticsCount} / {totalCount}
            <br />
            Complete With Score & Analytics Count: {completeWithScoreAndAnalyticsCount} / {totalCount}
            <br />

            <Tooltip title="Sync Info">
                <Button
                    onClick={() => updateBatchStatus()}
                >
                    <SyncIcon />
                </Button>
            </Tooltip>
            <Tooltip title="Trigger">
                <Button
                    onClick={() => triggerNetworkBatch()}
                >
                    <ArrowForward />
                </Button>
            </Tooltip>
            <br />
            <Box sx={{ width: '100%', border: "solid" }}>
                <LinearProgress style={{ margin: "1px", width: totalActivePercentage, border: "" }} variant="buffer" 
                    determinate
                    value={completeWithAnalyticsProgress} valueBuffer={0} />
            </Box>
            <br />
            <DataGrid
                disableSelectionOnClick
                rows={networkRunQueueDataRows}
                columns={networkRunColumns}
                pagination={true}
                initialState={{
                    sorting: {
                        sortModel: [{ field: 'name', sort: 'desc' }, { field: 'audio_source_folder', sort: 'desc' }],
                    },
                }}
                components={{
                    Toolbar: () => CustomToolbar("Network_Run_Results" + (network_batch_id !== null ? "_" + network_batch_id : ""))
                }}
                autoHeight
            />
        </>
    )
});

export { NetworkRunQueueTable };
